<template>
	<div style="background-color: rgba(236, 245, 255, 1);" class="div2" >
	<div style="display: flex;width: 100%;">
		<div style="width: 45%;position: relative;">
			<div class="leftimg" style="background-image: url('/static/login/1.svg');">
				<div style="margin-top: 80px;text-align: center;color: #fff;font-size: 18px;font-weight: bold;">
					<img src="/static/login/3.svg"/><br/><br/>
					答题管理平台</div>
				<div style="margin-top: 10px;text-align: center;color: #fff;font-size: 18px;font-weight: bold;">Answering system platform</div>
				<!-- <div class="divimg">
					<img src="/static/login/1.svg" class="img"/>
				</div> -->
			</div>
		</div>
		<div style="width: 55%;">
			<el-form ref="loginForm" :model="form" :rules="rules" label-width="80px" class="login-box">
					<h3 class="login-title">用户登录 USER LOGIN</h3>
					<el-form-item label="用户名" prop="username">
						<el-input type="text" placeholder="请输入用户名" v-model="form.username" />
					</el-form-item>
					<el-form-item label="密码" prop="password">
						<el-input type="password" placeholder="请输入密码" v-model="form.password" />
					</el-form-item>
					<el-form-item label="验证码" prop="code">
						<div style="display: flex;">
							<el-input type="text" placeholder="请输入密码" v-model="form.code" style="width: 220px;" />
						<img :src="imageSrc" style="width: 80px;height: 40px;margin-left: 5px;" @click="refeshImg"/>
						</div>
					
					</el-form-item>
					<el-form-item label-width="50px">
						<div style="height: 10px;">&nbsp;</div>
						<el-button type="primary" @click="onSubmit('loginForm')" style="width: 90%;">登录</el-button>
					</el-form-item>
				</el-form>
			
		<el-dialog title="温馨提示" :visible.sync="dialogVisible" width="30%" :before-close="handleClose">
			<span>请输入用户名和密码</span>
			<span slot="footer" class="dialog-footer">
				<el-button type="primary" @click="dialogVisible = false">确 定</el-button>
			</span>
		</el-dialog>
		</div>
	</div>
	<div style="width: 100%;text-align: center;margin-top: 10px;color: grey;">版权所有 &nbsp;&nbsp; ©2025 &nbsp;&nbsp; All Right Reserved &nbsp;&nbsp;
			 <a href="https://beian.miit.gov.cn" target="_blank " rel="nofollow" style="color: grey;">浙ICP备2023041348号-2 </a></div>
</div>

</template>
<script>
export default {
	name: "login",
	data() {
		return {
			form: {
				username: 'admin',
				password: '123456',
				code:'1234'
			},
			// 表单验证，需要在 el-form-item 元素中增加 prop 属性
			rules: {
				username: [{
					required: true,
					message: '用户名不可为空',
					trigger: 'blur'
				}],
				password: [{
					required: true,
					message: '密码不可为空',
					trigger: 'blur'
				}],
				code: [{
					required: true,
					message: '验证码不可为空',
					trigger: 'blur'
				}]
			},
			// 对话框显示和隐藏
			dialogVisible: false,
			logining: false,
			ruleForm2: {
				account: 'admin',
				checkPass: '123456'
			},
			rules2: {
				account: [{
					required: true,
					message: '请输入用户名',
					trigger: 'blur'
				},
					//{ validator: validaePass }
				],
				checkPass: [{
					required: true,
					message: '请输入密码',
					trigger: 'blur'
				},
					//{ validator: validaePass2 }
				]
			},
			checked: true,
			imageSrc:''
		}
	},
	methods: {
		onSubmit(formName) {
			// 为表单绑定验证功能
			this.$refs[formName].validate((valid) => {
				if (valid) {


					let formData = new FormData();
					formData.append("userCode", this.form.username);
					formData.append("password", this.form.password);
					formData.append("code", this.form.code);

					this.$axios.post("/home/login", formData).then(res => {
						//console.log(res.data);
						if (res.data.status == 0) {
							localStorage.setItem("token", res.data.data.token);
							localStorage.setItem("userName", res.data.data.userName);
							localStorage.setItem("logName", this.form.username);
							localStorage.setItem("childCodes", res.data.data.childCodes);
							this.getMenu(res.data.data.purviews);
							this.$router.push("/backadmin/dashboard");
						}
						else {
							this.$message(res.data.msg);
						}

						// 防止重复配置相同路由
						/* if (this.$router.options.routes.length <= 1) {
							let routes=this.getMenu();
							this.$router.addRoutes(routes)
							// this.$router不是响应式的，所以手动将路由元注入路由对象
							this.$router.options.routes.push(routes)
						} */

					})
				} else {
					//this.dialogVisible = true;
					return false;
				}
			});
		},
		rest() {
			this.$refs.loginForm.resetFields();
			return false;
		},
		handleClose() {

		},
		getMenu(menuArr) {
			let menuPage = [];
			let dashboardObj = {
				path: "/",
				name: "首页",
				viewPath: "views/Home.vue",
				iconCls: "",
				children: [{
					path: "/backadmin/dashboard",
					name: "工作台",
					viewPath: "views/dashboard.vue",
					iconCls: "el-icon-user-solid",
					children: []
				}]
			};
			menuPage.push(dashboardObj);
			menuArr.forEach(function (item, index) {
				let menuObj = {
					path: "/",
					name: item.moduleName,
					viewPath: "views/Home.vue",
					iconCls: item.iconcls,
					componentName: item.purviewCode,
				};
				if (item.eslpurviewslist) {
					menuObj.children = [];
					item.eslpurviewslist.forEach(function (item2, index) {
						menuObj.children.push({
							path: item2.purviewPageURL,
							name: item2.purviewName,
							viewPath: item2.viewPath,
						});
					});
				};
				menuPage.push(menuObj);
			});

			//console.log(menuPage);

			/* let menuArr = [{
				path: '/',
				name: '系统管理',
				viewPath:"views/Home.vue",
				iconCls: 'el-icon-user-solid',
				children: [{
						path: '/list3',
						name: '测试列表',
						viewPath:"views/demo/list3.vue"
					}
				]
			}]; */
			localStorage.setItem("MenuData", JSON.stringify(menuPage));
			return menuPage;
		},
		refeshImg(){
			this.imageSrc=this.$axios.defaults.baseURL+'/home/captcha?t='+new Date().getTime()
		}
		
	},
	created(){
		this.refeshImg()
	}
}
</script>
<style scoped lang="scss">
.div2 {
	height: calc(100vh);
	padding-top: 80px;
	width: 100%;
	background-color: rgba(236, 245, 255, 1);
	//  background: linear-gradient(to right, burlywood, blue);
}
.leftimg{
	position: absolute;
    right: 0px;
    top: 0px;
	border-width: 0px;
    width: 330px;
    height: 540px;
    -moz-box-shadow: none;
    -webkit-box-shadow: none;
    box-shadow: none;
	.divimg{
		border-width: 0px;
		position:absolute;
		left:0px;
		top:0px;
		width:330px;
		height:540px;
		.img{
			border-width: 0px;
			position:absolute;
			left:0px;
			top:0px;
		}
	}
}

.login-box {
	border: 0px solid #DCDFE6;
	width: 400px;
	height: 520px;
	padding: 5px 35px 15px 5px;
	border-radius: 5px;
	-webkit-border-radius: 5px;
	-moz-border-radius: 5px;
	box-shadow: 0 0 15px #909399;
	background-color: #fff;
}

.login-title {
	text-align: left;
	margin-left:15px;
	margin-bottom: 80px;
	color: #303133;
}
</style>
